export enum InventoryTransactionType {
    PlasticsHardware = 'PlasticsHardware',
    PlasticsProduct = 'PlasticsProduct',
    PlasticsMaterial = 'PlasticsMaterial',
    MetalsHardware = 'MetalsHardware',
    MetalsProduct = 'MetalsProduct',
    C3Hardware = 'C3Hardware',
    C3Product = 'C3Product',
    ObsessedEngineeringComponent = 'ObsessedEngineeringComponent',
    ObsessedEngineeringProduct = 'ObsessedEngineeringProduct',
    InjectionMoldingHardware = 'InjectionMoldingHardware',
    InjectionMoldingMaterial = 'InjectionMoldingMaterial',
    InjectionMoldingProduct = 'InjectionMoldingProduct',
}

export interface InventoryTransaction {
    id: string;
    entityId: string;
    change: number;
    comment: string;
    createdOn: Date;
    createdById: string;
    type: InventoryTransactionType;
    processId?: string;
    transactionGroupId?: string;
}
